import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useWorkspaceDeveloperRequestsQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.requests(r),
	queryFn: () => n.requests(r),
	enabled: i
});
//#endregion
export { r as useWorkspaceDeveloperRequestsQuery };
